module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-12"
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "mb-4 row"
  }, [_c('div', {
    staticClass: "col-6"
  }, [_c('general-input', {
    attrs: {
      "label": "Inbrengcode",
      "placeholder": "Zoek met inbrengcode"
    },
    model: {
      value: (_vm.filters.code),
      callback: function($$v) {
        _vm.$set(_vm.filters, "code", $$v)
      },
      expression: "filters.code"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "col-6"
  }, [_c('general-input', {
    attrs: {
      "label": "Naam",
      "placeholder": "Zoek op naam"
    },
    model: {
      value: (_vm.filters.name),
      callback: function($$v) {
        _vm.$set(_vm.filters, "name", $$v)
      },
      expression: "filters.name"
    }
  })], 1)]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-12 d-flex justify-content-end"
  }, [_c('b-pagination-nav', {
    attrs: {
      "link-gen": _vm.linkGen,
      "number-of-pages": _vm.persons.last_page,
      "value": _vm.persons.current_page,
      "use-router": "",
      "align": "right"
    }
  })], 1)]), _vm._v(" "), (_vm.error) ? _c('b-alert', {
    attrs: {
      "variant": "danger",
      "show": ""
    }
  }, [_vm._v(_vm._s(_vm.error))]) : _vm._e(), _vm._v(" "), _c('partial-loader', {
    attrs: {
      "loading": _vm.isFetching
    }
  }), _vm._v(" "), (!_vm.isFetching) ? _c('b-table', {
    attrs: {
      "striped": "",
      "hover": "",
      "show-empty": "",
      "items": _vm.persons.data,
      "fields": _vm.fields,
      "per-page": parseInt(_vm.persons.per_page),
      "busy": _vm.isFetching,
      "empty-text": _vm.$t('seller.listEmptyText'),
      "empty-filtered-text": _vm.$t('seller.listEmptyFilteredText'),
      "sort-by": _vm.sortBy,
      "sort-desc": _vm.sortDesc,
      "no-local-sorting": true
    },
    on: {
      "update:sortBy": function($event) {
        _vm.sortBy = $event
      },
      "update:sort-by": function($event) {
        _vm.sortBy = $event
      },
      "update:sortDesc": function($event) {
        _vm.sortDesc = $event
      },
      "update:sort-desc": function($event) {
        _vm.sortDesc = $event
      }
    },
    scopedSlots: _vm._u([{
      key: "cell(actions)",
      fn: function(row) {
        return [_c('b-btn-group', {
          staticClass: "pull-right"
        }, [_c('b-btn', {
          attrs: {
            "variant": "outline-primary",
            "to": {
              name: 'auctionSeller',
              params: {
                personId: row.item.id
              },
              query: {
                back: 'auctionSellers'
              }
            }
          }
        }, [_c('i', {
          staticClass: "fa fa-fw fa-eye"
        })]), _vm._v(" "), _c('b-btn', {
          attrs: {
            "variant": "outline-primary",
            "to": {
              name: 'itemList',
              query: {
                sellerId: row.item.id
              }
            }
          }
        }, [_c('fa-icon', {
          attrs: {
            "icon": "boxes"
          }
        })], 1)], 1)]
      }
    }, {
      key: "cell(items)",
      fn: function(row) {
        return [_vm._v("\n\t \t\t\t" + _vm._s(row.item.auction_items) + "\n\t \t\t")]
      }
    }], null, false, 2246322750)
  }) : _vm._e(), _vm._v(" "), _c('b-pagination-nav', {
    attrs: {
      "link-gen": _vm.linkGen,
      "number-of-pages": _vm.persons.last_page,
      "value": _vm.persons.current_page,
      "use-router": "",
      "align": "right"
    }
  })], 1)])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [_c('h1', {
    staticClass: "display-4"
  }, [_vm._v("Inbrengers")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-a3c8a40a"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/views/Auction/Seller/SellerList.vue
// module id = 1334
// module chunks = 1